'use strict';

var getScrollY = require('./getScrollY');

/**
 * Waits for elastic bounce to finish.
 * Thanks to rAF calls, it doesn't cause unneccessary layout.
 */
function waitForElasticScroll() {
  return new Promise(function (resolve) {
    window.requestAnimationFrame(function () {
      var maxScrollY = document.body.scrollHeight - window.innerHeight;

      function isReady() {
        var scrollY = getScrollY();
        return scrollY >= 0 && scrollY <= maxScrollY;
      }

      function resolveIfReady() {
        if (isReady()) {
          resolve();
        } else {
          window.requestAnimationFrame(resolveIfReady);
        }
      }

      resolveIfReady();

    });
  });
}

module.exports = waitForElasticScroll;



/** WEBPACK FOOTER **
 ** ./utils/waitForElasticScroll.js
 **/